/** WhatsApp refuses a body longer than this, so the user must never discover it from a server error. */
export const WHATSAPP_MAX_BODY_CHARS = 4096;

/** The counter stays out of the way until the body is close enough to the ceiling to matter. */
export const COUNTER_VISIBLE_FROM = 3800;

// Attachments and the body limit follow Compose Email's handling, per design: Send is
// disabled and the reason sits on the button, rather than a bespoke error surface.
// One flat 5 MB cap for every type, chosen over WhatsApp's own per-type ceilings
// (documents 100 MB, images 5 MB, video 16 MB) because a single number is explainable and
// sits under all of them. F2's per-type limits are the later refinement.
// Named WHATSAPP_-prefixed: ComposeEmailModal.constants.ts exports MAX_ATTACHMENT_BYTES /
// ATTACHMENT_OVER_LIMIT_MESSAGE too, at a different value (9 MB) — a same-named import from
// the wrong file would silently apply the wrong cap.
export const WHATSAPP_MAX_ATTACHMENT_BYTES = 5 * 1024 * 1024;
export const WHATSAPP_ATTACHMENT_OVER_LIMIT_MESSAGE = 'Attachments exceed 5 MB. Remove a file to send.';
export const BODY_OVER_LIMIT_MESSAGE = `Message exceeds ${WHATSAPP_MAX_BODY_CHARS} characters. Shorten it to send.`;
/** The other empty-recipients case (C3/AC-RC-04): the initial fetch itself returned no chats. */
export const NO_GROUP_MESSAGE = 'No WhatsApp group tagged for the selected lenders.';

export const TOOLBAR_HOST_ID = 'softCheckToolbarHost';

// The unifier returns one entry per ServiceDefinition it fanned out to, keyed by the
// definition's id — `{responseBody: {<SERVICE_ID>: <the service's own envelope>}}`. So the
// payload is two levels deeper than a direct call's, and reading `res.data` gets the
// wrapper rather than the answer.
export const ELIGIBLE_CHATS_SERVICE = 'UW_WHATSAPP_ELIGIBLE_CHATS';
export const SEND_SERVICE = 'AION_WHATSAPP_SEND';

/** Every remaining group already has the message — there is nothing left for Send to do. */
export const ALL_SENT_MESSAGE = 'Every remaining group already has this message.';

/** The eligible-chats fetch itself failed — distinct from NO_GROUP_MESSAGE, where it succeeded with zero groups. */
export const LOAD_CHATS_ERROR_MESSAGE = 'Could not load WhatsApp groups for these lenders';
/** Covers both an empty results array and a thrown request error — see the catch in handleSend. */
export const SEND_ERROR_MESSAGE = 'Could not send the soft check. Please retry.';
/** Shown only when every pending recipient's send succeeded — a partial failure gets the per-lender toast instead. */
export const SEND_SUCCESS_MESSAGE = 'WhatsApp sent successfully!';
